export default __webpack_public_path__ + "static/media/a036-1.a2d86777.svg";